import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FailedReadingOptions, ReadingStatus } from 'src/app/models/meterReading.model';
import { PermissionsEnum } from 'src/app/models/role.model';
import { User } from 'src/app/models/user.model';
import { OptionObj } from 'src/app/models/util.model';
import { MeterReadingService } from 'src/app/services/meter-readings.service';
import { PermissionsService } from 'shared-lib';
import { AuthService } from 'src/app/services/auth.service';
import { TranslationService } from 'src/app/services/translation.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-reading-details',
  templateUrl: './reading-details.component.html',
  styleUrls: ['./reading-details.component.scss'],
})
export class ReadingDetailsComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    public permissionsService: PermissionsService,
    public meterReadingService: MeterReadingService,
    private translationService: TranslationService,
    private renderer: Renderer2,
    public userService: UserService,
    public authService: AuthService
  ) {}
  ReadingStatus = ReadingStatus;
  PermissionsEnum = PermissionsEnum;
  FailedReadingOptions = FailedReadingOptions;
  failedReadingOptions: OptionObj[] = [
    { key: FailedReadingOptions.RealReading, value: 'READING.REAL_READING' },
    { key: FailedReadingOptions.AIReading, value: 'READING.AI_READING' },
    { key: FailedReadingOptions.Retake, value: 'READING.RETAKE' },
  ];

  retakeOptions: OptionObj[] = [
    { key: 1, value: 'READING.SAME_METER_READER' },
    { key: 2, value: 'READING.ANOTHER_METER_READER' },
  ];

  selectedImage: any;
  isImageMapVisible: boolean = false;
  meterReading: any | undefined;
  id: string = '';
  editEnabled: boolean = false;
  onlyView: boolean = false;
  searchFilterApplied: boolean = false;
  selectedFailedReadingOption: FailedReadingOptions = FailedReadingOptions.RealReading;
  selectedRetakeOption: number = 0;
  buName: string = this.translationService.getByKeyFromStorage('BU');
  utName: string = this.translationService.getByKeyFromStorage('UT');

  placeholderImage: string = '../../../../assets/no-image.png';
  imgZoomFullContainer: any;
  currentRotation: number = 0;
  imgElement: any;

  priorityStatus: any[];
  buildingInformation: any[];
  readingInformation: any[];
  accountInformation: any[];
  meterInformation: any[];
  inaccessible: any[];
  inoperableMeter: any[];

  showUpdateStatus: boolean = false;
  filterText: string = '';
  isDropdownOpened: boolean = false;
  filteredMobileUsers: User[] = [];
  tempAssignedUserId: number = 0;
  mobileUsers: User[] = [];

  ngOnInit(): void {
    const readingId = this.activatedRoute.snapshot.paramMap.get('id');
    this.id = readingId || '';
    this.getMeterReading(readingId);
  }

  private getMeterReading(Id: any) {
    this.meterReadingService.get(Id).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.meterReading = responseData.data;
          this.generateSections();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  updateReading(){
    var obj = {
      id: parseInt(this.id),
      assignedUserId: this.tempAssignedUserId != 0 && this.selectedRetakeOption === 2 ? this.tempAssignedUserId : null,
      failedReadingOption: this.selectedFailedReadingOption
    }

    this.meterReadingService.update(obj).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          window.location.reload();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  rotateRight() {
    this.currentRotation += 90;
  }

  rotateLeft() {
    this.currentRotation -= 90;
  }

  onModalOpen() {
    this.renderer.setStyle(document.body, 'overflow', 'auto');
    this.renderer.setStyle(document.body, 'overflow-x', 'hidden');
    this.renderer.setStyle(document.body, 'padding-right', '0');
  }

  showImage(image: any) {
    this.selectedImage = image;
  }
  onModalFade() {
    this.currentRotation = 0;

    if (this.imgZoomFullContainer) {
      var displayValue = getComputedStyle(this.imgZoomFullContainer).display;

      if (displayValue == 'block') {
        this.imgElement.click();
      }
    }

    this.selectedImage = null;
  }

  generateSections() {
    this.buildingInformation = [
      {
        title: 'READING.DETAILS.BUILDING_INFOMRATION_CARD.BUILDING_OWNER_NAME',
        value: this.meterReading?.buildingOwnerName,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'COMMON.BU.SINGLE',
        value: this.authService.hasCimDataIntegration
          ? this.meterReading?.subGeographicalRegion?.geographicalRegionName
          : this.meterReading?.region,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'COMMON.UT.SINGLE',
        value: this.authService.hasCimDataIntegration
          ? this.meterReading?.subGeographicalRegion?.name
          : this.meterReading?.district,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.BUILDING_INFOMRATION_CARD.GEO_CODE',
        value: this.meterReading?.geocode,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.BLOCK',
        value: this.meterReading?.block,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.ROUND',
        value: this.meterReading?.round,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.BUILDING_INFOMRATION_CARD.PLOT',
        value: this.meterReading?.plot,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.BUILDING_INFOMRATION_CARD.ADDRESS',
        value: this.meterReading?.address,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.BUILDING_INFOMRATION_CARD.GHANA_POST_ADDRESS',
        value: this.meterReading?.ghanaPostAddress,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.BUILDING_INFOMRATION_CARD.GEO_LOCATION',
        value: `${this.meterReading?.latitude ?? ''}, ${
          this.meterReading?.longitude ?? ''
        }`,
        titleWidth: 'col-5',
        bodyWidth: 'col-6',
        isGeoLocation: true,
      },
    ];
    this.readingInformation = [
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.READ_VALIDATION',
        value: this.meterReading?.readValidation,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.PERIOD',
        value: this.meterReading?.period,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.LAR',
        value: this.meterReading?.lar,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.PAR',
        value: this.meterReading?.par,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.MF',
        value: this.meterReading?.mf,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.CONSUMPTION_KWH',
        value: this.meterReading?.consumptionKwh,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.MAX_DEMAND',
        value: this.meterReading?.maxDemand,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.LAR_KVAH',
        value: this.meterReading?.larKvah,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.PAR_KVAH',
        value: this.meterReading?.parKvah,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.APPARENT_POWER',
        value: this.meterReading?.apparentPower,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.POWER_FACTOR',
        value: this.meterReading?.powerFactor,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.BILL_AMOUNT',
        value: this.meterReading?.billAmount,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.DAILY_AVERAGE',
        value: this.meterReading?.dailyAverage,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.READ_SOURCE',
        value: this.meterReading?.readSource,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.TREAT_AS_ACTUAL',
        value: this.meterReading?.treatAsActual,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.AUDIT_STATUS',
        value: this.meterReading?.auditStatus,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.MESSAGE_DESCRIPTION',
        value: this.meterReading?.messageDescription,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
      {
        title: 'READING.DETAILS.READING_INFORMATION_CARD.AI_PREDICTED_VALUE',
        value: this.meterReading?.aiPredictedValue,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },{
        title: 'READING.DETAILS.READING_INFORMATION_CARD.AI_DETAILS',
        value: this.meterReading?.aiDetails,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },{
        title: 'READING.DETAILS.READING_INFORMATION_CARD.AI_MESSAGE',
        value: this.meterReading?.aiMessage,
        titleWidth: 'col-5',
        bodyWidth: 'col-7',
      },
    ];
    this.accountInformation = [
      {
        title: 'READING.DETAILS.ACCOUNT_INFORMATION_CARD.ACCOUNT_NUMBER',
        value: this.meterReading?.accountNumber,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.ACCOUNT_INFORMATION_CARD.SPN',
        value: this.meterReading?.spn,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.ACCOUNT_INFORMATION_CARD.CUSTOMER_ID',
        value: this.meterReading?.customerId,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.ACCOUNT_INFORMATION_CARD.TARIFF_CLASS',
        value: this.meterReading?.tariffClass,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.ACCOUNT_INFORMATION_CARD.SLT_STATUS',
        value: this.meterReading?.sltStatus,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.ACCOUNT_INFORMATION_CARD.CONTRACT_STATUS',
        value: this.meterReading?.contractStatus,
        titleWidth: 'col-6',
        bodyWidth: 'col-6',
      },
    ];
    this.meterInformation = [
      {
        title: 'READING.DETAILS.METER_INFOMRATION_CARD.METER_NUMBER',
        value: this.meterReading?.meterNumber,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.METER_INFOMRATION_CARD.METER_DIGIT',
        value: this.meterReading?.meterCode,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.METER_INFOMRATION_CARD.METER_CODE',
        value: this.meterReading?.meterDigit,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
    ];
    this.inaccessible = [
      {
        title: 'READING.DETAILS.INACCESSIBLE_METER_INFORMATION_CARD.INACCESSIBLE_ISSUE',
        value: this.meterReading?.inaccessibleIssue,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.INACCESSIBLE_METER_INFORMATION_CARD.REMARK_AND_COMMENT',
        value: this.meterReading?.remarkAndComment,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
    ];
    this.inoperableMeter = [
      {
        title: 'READING.DETAILS.INOPERABLE_METER_INFORMATION_CARD.METER_CONDITION',
        value: this.meterReading?.meterCondition,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
      {
        title: 'READING.DETAILS.INOPERABLE_METER_INFORMATION_CARD.REMARK_AND_COMMENT',
        value: this.meterReading?.remarkAndComment,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
    ];
    this.priorityStatus = [
      {
        title: 'READING.DETAILS.PRIORITY',
        value: this.meterReading?.priority,
        titleWidth: 'col-4',
        bodyWidth: 'col-8',
      },
    ];
  }

  cancelModal() {
    this.showUpdateStatus = false;
  }

  onOptionSelected(event: any) {
    this.selectedFailedReadingOption = parseInt(event.target.value);
  }

  onRetakeOptionSelected(event: any) {
    this.selectedRetakeOption = parseInt(event.target.value);
  }

  filterMobileUsers() {
    if (this.filterText.length < 3) {
      return;
    }
    this.isDropdownOpened = true;
    this.tempAssignedUserId = 0;
    this.getMobileUsers();
  }
  getMobileUsers() {
    this.userService.getMobileUsers(this.meterReading.areaId, this.filterText).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.mobileUsers = responseData.data;
          if (this.mobileUsers.length == 0) {
            this.isDropdownOpened = false;
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  selectFieldAgent(id: number) {
    this.isDropdownOpened = false;
    this.tempAssignedUserId = id;
    var mobUser = this.mobileUsers.find((x) => x.id == id);
    if (mobUser?.firstName && mobUser?.lastName) {
      this.filterText = mobUser!.firstName + ' ' + mobUser?.lastName;
    } else {
      this.filterText = mobUser!.firstName;
    }
  }
}
